import { GetChatToUpdate } from '../../../modules/chat/types/chat.types';
import { BRAND_ID_HEADER_KEY, restApi } from '../../api';
import {
  FindChatOutput,
  FindChatParams,
  FindGroupedChatsOutput,
  FindGroupedChatsParams,
  FindMainChatBetweenStoreAndBrandOutput,
  FindMainChatBetweenStoreAndBrandParams,
  GetAllChatsNotificationsOutput,
} from './chats.types';

const PATH = 'chats';

export const findChats = (params: FindChatParams) => restApi.get<FindChatOutput>(`${PATH}`, params);

export const getAllChatsNotifications = () =>
  restApi.get<GetAllChatsNotificationsOutput>(`${PATH}/notifications`);

export const updateLastViewedMessageByChatId = (chatId: string, lastViewedChatMessageId: string) =>
  restApi.put(`${PATH}/${chatId}/last-viewed-message`, { lastViewedChatMessageId });

export const findGroupedChats = (params: FindGroupedChatsParams) =>
  restApi.get<FindGroupedChatsOutput>(`${PATH}/grouped`, params);

export const findMainChatBetweenStoreAndBrand = ({
  brandId,
  storeId,
}: FindMainChatBetweenStoreAndBrandParams) =>
  restApi.get<FindMainChatBetweenStoreAndBrandOutput>(
    `${PATH}/main`,
    { storeId },
    {
      headers: {
        [BRAND_ID_HEADER_KEY]: brandId,
      },
    },
  );

export const getChatToUpdate = (chatId: string) =>
  restApi.get<GetChatToUpdate>(`${PATH}/${chatId}/to-update`);
